export function getVersion() {
  return import.meta.env.VUE_APP_VERSION || 'unknown'
}
